import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from '../services/date-time.service';
import { TimezoneName } from '../services/timzones.constants';
import { ProfileService } from '../services/profile.service';

@Pipe({
  name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {

  constructor(
    private readonly dateTimeService: DateTimeService,
    private readonly profileService: ProfileService,
  ) { }

  transform(value: string | undefined, isUTC: boolean = true): unknown {
    // console.log('converting to: ', this.profileService.timezone);
    if(value) {
      return this.dateTimeService.toZoneDate(
        isUTC ? value : this.dateTimeService.toUTCDate(value),
        this.profileService.timezone
      );
    }
    return '-';
  }
}
